// import axios from "axios";
import { errorMessage } from "@/api/errorMessages";
import swal from "sweetalert";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getReport(_, route) {
      /* Fetch */
      const body = {
        channel: "C05PF97P474",
        text:
          "<@UMXUB46TE> New falcon issue in quote " +
          process.env.VUE_APP_BACK_ROUTE.replace("api-", "") +
          route
      };
      fetch(
        "https://hooks.slack.com/services/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",
        {
          method: "POST",
          body: JSON.stringify(body),
          header: { "Content-type": "application/json" }
        }
      )
        .then(response => {
          swal({
            title: "Success!",
            text: "your report has been sent successfully",
            icon: "success",
            buttons: false,
            timer: 2000
          });
          return response;
        })
        .catch(error => {
          errorMessage();
          return error;
        });

      /* Axios */
      /* let body = {
        channel: "C05PF97P474",
        text:
          "<@UMXUB46TE> New falcon issue in quote " +
          process.env.VUE_APP_BACK_ROUTE +
          route
      };
      try {
        let response = await axios.post(
          `https://hooks.slack.com/services/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`,
          body,
          {
            headers: {
              "Content-type": "application/json"
            }
          }
        );
        if (response.status === 200) {
          // commit("setAccessorials", response.data);
        }
      } catch (err) {
        errorMessage();
        return err.response;
      } */
    }
  }
};
